import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import ReactMarkdown from "react-markdown";
function Markdown(props) {
    const { contents } = props;
    return _jsx(ReactMarkdown, { className: "tol-markdown", children: contents });
}
export default Markdown;
